<template>
    <footer class="r-footer">
        <y-container>
            <div class="r-footer__head-part">
                <router-link
                    v-if="$settings('site_logos.footer.link')"
                    :to="{ name: 'home' }"
                >
                    <img
                        :src="$settings('site_logos.footer.link')"
                        :alt="$settings('site_title.site_title')"
                        class="r-footer__logo"
                    >
                </router-link>

                <div class="r-footer__copyRight">
                    <p
                        v-if="$settings('copy_right.copy_right')"
                        class="r-footer__copyRight__text"
                        v-html="$settings('copy_right.copy_right')"
                    />
                </div>
            </div>
            <y-row class="pb-3">
                <y-col md="3">
                    <div>
                        <div class="r-footer__section-title newsletter">
                            <span>{{ $t('general.footer.newsletter_section_title') }}</span>
                        </div>
                        <p
                            v-if="$settings('content.footer-about')"
                            class="r-footer__site-dec"
                        >
                            {{ $settings('content.footer-about') }}
                        </p>
                        <div class="r-footer__newsletter__form">
                            <y-input
                                v-model="model.email"
                                :placeholder="$t('general.footer.placeholder')"
                                color="white"
                                size="large"
                                no-label
                                class="mb-8"
                            />
                            <y-button
                                :content="$t('general.footer.newsletter_button')"
                                color="primary"
                                loading-on="saving-comment"
                                size="medium"
                                class="submit-email-btn"
                                flat
                                :no-padding="false"
                                @click.prevent="beforeSubmit"
                            />
                        </div>

                        <y-recaptcha
                            v-if="$settings('recaptcha')"
                            ref="recaptcha"
                            :site-key="$settings('recaptcha.site_key')"
                            :size="$settings('recaptcha.size')"
                            @verify="afterVerify"
                        />
                    </div>
                </y-col>
                <y-col md="7">
                    <y-row class="r-footer__menu">
                        <y-col
                            md="4"
                            class="r-footer__menu--1col"
                        >
                            <div class="r-footer__section-title">
                                <span>{{ $settings('content.footer-footer1-title') }}</span>
                            </div>
                            <y-menu :items="getMenu('footer1-$')" />
                        </y-col>
                        <y-col
                            md="4"
                            size="6"
                        >
                            <div class="r-footer__section-title">
                                <span>{{ $settings('content.footer-footer2-title') }}</span>
                            </div>
                            <y-menu
                                :items="getMenu('footer2-$')"
                            />
                        </y-col>
                        <y-col
                            md="4"
                            size="6"
                        >
                            <div class="r-footer__section-title">
                                <span> {{ $settings('content.footer-footer3-title') }} </span>
                            </div>
                            <y-menu
                                :items="getMenu('footer3-$')"
                            />
                        </y-col>
                    </y-row>
                </y-col>
                <y-col md="2">
                    <div class="r-footer__contact">
                        <y-row>
                            <y-col
                                md="12"
                                size="6"
                            >
                                <div class="r-footer__section-title">
                                    <span>{{ $settings('content.footer-email-title') }}</span>
                                </div>

                                <div class="r-footer__contact__info">
                                    <a :href="`mailto:${$settings(`contact_details.elements.0.email.${$i18n.locale }.0`)}`">
                                        {{ $settings(`contact_details.elements.0.email.${$i18n.locale }.0`) }}
                                    </a>
                                </div>
                                <div class="r-footer__connect-social">
                                    <a
                                        v-if="$settings('content.footer-whatsapp')"
                                        :href="$settings('content.footer-whatsapp')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            alt="whatsapp"
                                            width="24"
                                            height="24"
                                            src="../../../assets/images/whatsapp-white.svg"
                                        >
                                    </a>
                                    <a
                                        v-if="$settings('content.footer-telegram')"
                                        :href="$settings('content.footer-telegram')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            alt="telegram"
                                            width="24"
                                            height="24"
                                            src="../../../assets/images/telegram-white.svg"
                                        >
                                    </a>
                                    <a
                                        v-if="$settings('content.footer-discord')"
                                        :href="$settings('content.footer-discord')"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img
                                            alt="discord"
                                            width="24"
                                            height="24"
                                            src="../../../assets/images/discord-white.svg"
                                        >
                                    </a>
                                </div>
                            </y-col>

                            <y-col
                                md="12"
                                size="6"
                            >
                                <div class="r-footer__section-title">
                                    <span>{{ $t('general.footer.find_us_on') }}</span>
                                </div>
                                <y-socials
                                    class="r-footer__contact__socials-items"
                                    :aparat="$settings('socials').aparat"
                                    :github="$settings('socials').github"
                                    :virgool="$settings('socials').virgool"
                                    :twitter="$settings('socials').twitter"
                                    :behance="$settings('socials').behance"
                                    :youtube="$settings('socials').youtube"
                                    :whatsapp="$settings('socials').whatsapp"
                                    :linkedin="$settings('socials').linkedin"
                                    :telegram="$settings('socials').telegram"
                                    :facebook="$settings('socials').facebook"
                                    :dribbble="$settings('socials').dribbble"
                                    :instagram="$settings('socials').instagram"
                                    :pinterest="$settings('socials').pinterest"
                                    :wordpress="$settings('socials').wordpress"
                                    size="small"
                                    svg-size="24px"
                                />
                            </y-col>
                        </y-row>
                    </div>
                </y-col>
            </y-row>
        </y-container>
    </footer>
</template>

<script>
    import {
        YMenu,
        YInput,
        YSocials,
        YRecaptcha,
    } from '@groot-components/all';

    export default {

        name: 'Footer',

        components: {
            YMenu,
            YInput,
            YSocials,
            YRecaptcha,
        },

        props: {
            /**
             * Show newsletter
             */
            newsletter: Boolean,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                cta  : null,
                model: {
                    email: '',
                },
            };
        },

        /**
         * @inheritDoc
         */
        created() {
            if (this.newsletter) {
                this.fetch();
            }
        },

        methods: {
            /**
             * Verify recaptcha
             * Check recaptcha is active
             */
            beforeSubmit() {
                this.$wait.start('saving-comment');
                if (this.$settings('recaptcha')?.active_for_guests === '1') {
                    this.$refs.recaptcha.verify();
                } else {
                    this.save();
                }
            },

            /**
             * Set token and start Sending Comment
             *
             * @param {string} token
             */
            afterVerify(token) {
                this.model['g-recaptcha-response'] = token;
                this.save();
            },

            /**
             * Do send comment
             *
             * @returns {object}
             */
            save() {
                return this.$services.Commenting.commentSave({
                    ...this.model,
                    id  : this.get(this.cta, 'id'),
                    type: 'pages',
                    slug: 'newsletter',
                }).then(() => {
                    this.model = { email: '' };
                    this.$toast.success(this.$t('general.footer.success_msg'));
                }).catch((error) => {
                    this.handleError(error, this.$t('general.footer.error_msg'));
                }).finally(() => {
                    this.$wait.end('saving-comment');
                    this.$refs.recaptcha.reset();
                });
            },

            /**
             * fetch user info
             *
             * @returns {Promise}
             */
            fetch() {
                return this.$services.Content.postSingle({
                    type     : 'pages',
                    slug     : 'newsletter',
                    including: ['title', 'synopsis'],
                    locale   : this.$i18n.locale,
                }).then((response) => {
                    this.cta = response.data.results;
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };
</script>

<style lang="scss" src="./index.scss" />

